import React from 'react'
import './TeamcenterUpgradeMigration.css'
import TeamcenterUpgradeMigrationOverview from './TeamcenterUpgradeMigrationOverview'
import BannerImage from '../../../assets/other_image/UpgrateAndMigrate.jpg'
import Letsgetintouch from '../BusinessProcessAndChangeManagement/Letsgetintouch'
import Banner from '../Banner/Banner'
import FloatingContactUs from '../../floting_contact/FloatingContactUs'
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const TeamcenterUpgradeMigration = () => {
  return (
    <>
      {/* ✅ Meta Tags for SEO */}
      <Helmet>
        <title>Teamcenter Upgrade &amp; Migration Services in Pune | NexTech PLM</title>
        <meta name="description" content="Upgrade and migrate Teamcenter seamlessly with expert services in Pune, India. Nextech PLM ensures minimal downtime and smooth transitions." />
        <meta name="keywords" content="Teamcenter upgrade services, Teamcenter migration Pune, PLM version upgrade India, Teamcenter data migration, Teamcenter upgrade planning, PLM system migration" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <link rel="canonical" href="https://nextechplm.com/teamcenter-upgrade-migration" />
        <meta property="og:site_name" content="NexTech PLM Solutions" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Teamcenter Upgrade & Migration Services in Pune | NexTech PLM" />
        <meta property="og:description" content="Upgrade and migrate Teamcenter seamlessly with expert services in Pune, India. Nextech PLM ensures minimal downtime and smooth transitions." />
        <meta property="og:url" content="https://nextechplm.com/teamcenter-upgrade-migration" />
        <meta name="twitter:title" content="Teamcenter Upgrade & Migration Services in Pune | NexTech PLM" />
        <meta name="twitter:description" content="Upgrade and migrate Teamcenter seamlessly with expert services in Pune, India. Nextech PLM ensures minimal downtime and smooth transitions." />
      </Helmet>

      <section className="TeamcenterUpgradeMigration-management">
        <Banner
          image={BannerImage} // Pass the image for this page
          heading="Teamcenter Upgrade & Migration" // Pass the heading text for this page
        />

        <div>
          <FloatingContactUs />
        </div>

        <TeamcenterUpgradeMigrationOverview />

        <section style={{ background: "#f5f7fa" }}>
          <div className="benefits container">
            <h4 className="TeamcenterUpgradeMigration-page-heading">Unlock the Power :</h4>
            <h5 className="TeamcenterUpgradeMigration-subheading">
              Discover the Transformative Benefits of Teamcenter Upgrade & Migration with NexTech!
            </h5>
            <ul className="custom-bullets">
              <li>Expertise in pre-upgrade, upgrade and post-upgrade activities</li>
              <li>Expertise in code migration from older release to new release</li>
              <li>Expertise in using analysis and data model fixing tools</li>
              <li>Expertise in upgrade issue analysis</li>
              <li>Best-in-class user experience with improved information visibility in the new system</li>
              <li>Single source of data and processes in Teamcenter</li>
              <li>Better extensibility to map various business requirements</li>
              <li>
                Tight Integration of various applications like project management, requirement & system
                engineering, manufacturing, and many more
              </li>
            </ul>
          </div>
        </section>

        <section>
          <div className="solutions container">
            <div className="solutions-content">
              <div className="row">
                <div className="col-md-6 col-12">
                  <h4 className="TeamcenterUpgradeMigration-page-heading">Teamcenter Solutions</h4>
                  <ul className="custom-bullets">
                    <li>Legacy PDM/PLM to Teamcenter Migration</li>
                    <li>Teamcenter Migration to Cloud</li>
                    <li>Teamcenter Upgrade and Site Consolidation</li>
                  </ul>
                </div>

                <div className="col-md-6 col-12">
                  <div className="quick-links">
                    <h4>Quick Links</h4>
                    <ul>
                      <li>
                        <NavLink to="/teamcenter-manufacturing-data-process-management">
                          Manufacturing Data and Process Management
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-plm-erp-data-process-management">
                          PLM - ERP (SAP, Oracle, HANA) Data and Process Management
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-bom-management">
                          Product BOM and Variability Management
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-community-collaboration">
                          Teamcenter Community Collaboration
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-cybersecurity">
                          Teamcenter Cyber Security
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-cloud-implementation">
                          Teamcenter Implementation on Cloud
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-implementation">
                          Teamcenter Implementation
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>

        <section style={{ background: "#f5f7fa" }}>
          <div className="why-nextech container">
            <h4 className="TeamcenterUpgradeMigration-page-heading">Why NexTech?</h4>
            <h5 className="TeamcenterUpgradeMigration-subheading">
              For Upgrade, Migration and Consolidation
            </h5>
            <ul className="custom-bullets">
              <li>
                Flexible approaches to transitioning to meet business needs, best practices and dedicated
                Transition Team to make it most successful.
              </li>
              <li>
                Proven methodology for managing site, process change and integration and data transfer impact
                to ensure right business value to customer from these projects.
              </li>
              <li>Expertise in handling upgrade, transition and consolidation projects</li>
              <li>Best in class project management, resource management & risk management</li>
              <li>
                Reduced the turnaround time for upgrade, transition, consolidation and transition by employing
                and engaging right resources at right time
              </li>
              <li>
                More precise technology understanding enable timely delivery with quality at optimum cost
              </li>
            </ul>
          </div>
        </section>

        <Letsgetintouch />
      </section>
    </>
  )
}

export default TeamcenterUpgradeMigration
